import React, { useEffect, useState } from 'react'
import { Progress } from '@/components/ui/progress'
import { Logo } from '@/components/icons'

const InitialLoadingScreen = () => {
	const [progress, setProgress] = useState(0)

	useEffect(() => {
		const interval = setInterval(() => {
			setProgress(prevProgress => {
				if (prevProgress < 90) {
					return prevProgress + 5
				}
				return prevProgress
			})
		}, 300)

		return () => clearInterval(interval)
	}, [])

	return (
		<div className="fixed inset-0 flex flex-col items-center justify-center bg-white z-50">
			<div className="flex flex-col items-center gap-6">
				<Logo variant="color" />
				<Progress value={progress} className="w-64 h-2" />
				<p className="text-brand-primary-md text-sm mt-2">Ładowanie...</p>
			</div>
		</div>
	)
}

export default InitialLoadingScreen
